var render = function render(){var _vm=this,_c=_vm._self._c;return _c('agile',{attrs:{"dots":false,"navButtons":false,"autoplay":false,"autoplay-speed":5000,"speed":1000}},[_c('div',{staticClass:"slide"},[_c('img',{attrs:{"src":"img/sandwich.jpg","alt":"Langoustine"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }